module.exports = __webpack_public_path__ + "img/02—02—Device List > Carousel II > Dropdown.b6e9dfa6.jpg";